import React, {useEffect, useState } from "react";
import { FormControl, Select, MenuItem, FormHelperText} from "@mui/material";

const ShopSelect = ({ name, onChange, value, setValue, customerId, listShop, disabled,validate,error, ...props }) => {

  const oneShop = listShop.length == 1;
  
  return (
    <FormControl {...props} disabled={disabled}>
      <Select
        id={name}
        value={value}
        onChange={onChange}
        displayEmpty
        readOnly= {oneShop}
      >
        {listShop.map((shop) => (
          <MenuItem key={shop.shopId} value={shop.shopId}>
            {shop.shopName}
          </MenuItem>
        ))}

      </Select>
      {error && <FormHelperText sx={{ color: "#d32f2f" ,  marginLeft: 0}}>{validate.errors.shopId}</FormHelperText>}
    </FormControl>
  );
};

export default ShopSelect;
